import { setContext } from '@apollo/client/link/context';
import tokenManager from '../tokenManager';

const authLink = setContext(async (_, { headers }) => {
  try {
    await tokenManager.ensureValidToken();

    const token = tokenManager.getAccessToken();

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  } catch (error) {
    console.error('Error in auth link:', error);

    return {
      headers: {
        ...headers,
        authorization: '',
      },
    };
  }
});

export default authLink;